/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';

import { WorkCreateDebtorDto } from '../models/work-create-debtor-dto';
import { WorkDebtor } from '../models/work-debtor';
import { WorkDebtorLatestQrnumberDto } from '../models/work-debtor-latest-qrnumber-dto';
import { WorkPaginatedDocumented } from '../models/work-paginated-documented';
import { WorkSplitDebtorDto } from '../models/work-split-debtor-dto';
import { WorkUpdateDebtorDto } from '../models/work-update-debtor-dto';

@Injectable({ providedIn: 'root' })
export class WorkDebtorsV2Service extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `debtorsV2ControllerFindAllPaginated()` */
  static readonly DebtorsV2ControllerFindAllPaginatedPath = '/v2/debtors';

  /**
   * Required permissions: debtors:read, debtors:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `debtorsV2ControllerFindAllPaginated()` instead.
   *
   * This method doesn't expect any request body.
   */
  debtorsV2ControllerFindAllPaginated$Response(
    params?: {

    /**
     * Page number to retrieve.If you provide invalid value the default page number will applied
     *         <p>
     *              <b>Example: </b> 1
     *           </p>
     *         <p>
     *              <b>Default Value: </b> 1
     *           </p>
     */
      page?: number;

    /**
     * Number of records per page.
     *       <p>
     *              <b>Example: </b> 20
     *           </p>
     *       <p>
     *              <b>Default Value: </b> 50
     *           </p>
     *       <p>
     *              <b>Max Value: </b> 1000
     *           </p>
     *
     *       If provided value is greater than max value, max value will be applied.
     */
      limit?: number;

    /**
     * Filter by projectId query param.
     *           <p>
     *              <b>Format: </b> filter.projectId={$not}:OPERATION:VALUE
     *           </p>
     *           <p>
     *              <b>Example: </b> filter.projectId=$not:$like:John Doe&filter.projectId=like:John
     *           </p>
     *           <h4>Available Operations</h4><ul><li>$eq</li></ul>
     */
      'filter.projectId'?: Array<string>;

    /**
     * Parameter to sort by.
     *       <p>To sort by multiple fields, just provide query param multiple types. The order in url defines an order of sorting</p>
     *       <p>
     *              <b>Format: </b> fieldName:DIRECTION
     *           </p>
     *       <p>
     *              <b>Example: </b> sortBy=id:DESC&sortBy=createdAt:ASC
     *           </p>
     *       <p>
     *              <b>Default Value: </b> invoicing:ASC
     *           </p>
     *       <h4>Available Fields</h4><ul><li>created</li>
     * <li>invoicing</li>
     * <li>maturity</li>
     * <li>paid</li>
     * <li>amountIncl</li>
     * <li>amountExcl</li></ul>
     */
      sortBy?: Array<'created:ASC' | 'created:DESC' | 'invoicing:ASC' | 'invoicing:DESC' | 'maturity:ASC' | 'maturity:DESC' | 'paid:ASC' | 'paid:DESC' | 'amountIncl:ASC' | 'amountIncl:DESC' | 'amountExcl:ASC' | 'amountExcl:DESC'>;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkPaginatedDocumented & {
'data'?: Array<WorkDebtor>;
'meta'?: {
'select'?: Array<string>;
'filter'?: {
'projectId'?: (string | Array<string>);
};
};
}>> {
    const rb = new RequestBuilder(this.rootUrl, WorkDebtorsV2Service.DebtorsV2ControllerFindAllPaginatedPath, 'get');
    if (params) {
      rb.query('page', params.page, {});
      rb.query('limit', params.limit, {});
      rb.query('filter.projectId', params['filter.projectId'], {});
      rb.query('sortBy', params.sortBy, {});
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkPaginatedDocumented & {
        'data'?: Array<WorkDebtor>;
        'meta'?: {
        'select'?: Array<string>;
        'filter'?: {
        'projectId'?: (string | Array<string>);
        };
        };
        }>;
      })
    );
  }

  /**
   * Required permissions: debtors:read, debtors:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `debtorsV2ControllerFindAllPaginated$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  debtorsV2ControllerFindAllPaginated(
    params?: {

    /**
     * Page number to retrieve.If you provide invalid value the default page number will applied
     *         <p>
     *              <b>Example: </b> 1
     *           </p>
     *         <p>
     *              <b>Default Value: </b> 1
     *           </p>
     */
      page?: number;

    /**
     * Number of records per page.
     *       <p>
     *              <b>Example: </b> 20
     *           </p>
     *       <p>
     *              <b>Default Value: </b> 50
     *           </p>
     *       <p>
     *              <b>Max Value: </b> 1000
     *           </p>
     *
     *       If provided value is greater than max value, max value will be applied.
     */
      limit?: number;

    /**
     * Filter by projectId query param.
     *           <p>
     *              <b>Format: </b> filter.projectId={$not}:OPERATION:VALUE
     *           </p>
     *           <p>
     *              <b>Example: </b> filter.projectId=$not:$like:John Doe&filter.projectId=like:John
     *           </p>
     *           <h4>Available Operations</h4><ul><li>$eq</li></ul>
     */
      'filter.projectId'?: Array<string>;

    /**
     * Parameter to sort by.
     *       <p>To sort by multiple fields, just provide query param multiple types. The order in url defines an order of sorting</p>
     *       <p>
     *              <b>Format: </b> fieldName:DIRECTION
     *           </p>
     *       <p>
     *              <b>Example: </b> sortBy=id:DESC&sortBy=createdAt:ASC
     *           </p>
     *       <p>
     *              <b>Default Value: </b> invoicing:ASC
     *           </p>
     *       <h4>Available Fields</h4><ul><li>created</li>
     * <li>invoicing</li>
     * <li>maturity</li>
     * <li>paid</li>
     * <li>amountIncl</li>
     * <li>amountExcl</li></ul>
     */
      sortBy?: Array<'created:ASC' | 'created:DESC' | 'invoicing:ASC' | 'invoicing:DESC' | 'maturity:ASC' | 'maturity:DESC' | 'paid:ASC' | 'paid:DESC' | 'amountIncl:ASC' | 'amountIncl:DESC' | 'amountExcl:ASC' | 'amountExcl:DESC'>;
    },
    context?: HttpContext
  ): Observable<WorkPaginatedDocumented & {
'data'?: Array<WorkDebtor>;
'meta'?: {
'select'?: Array<string>;
'filter'?: {
'projectId'?: (string | Array<string>);
};
};
}> {
    return this.debtorsV2ControllerFindAllPaginated$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkPaginatedDocumented & {
'data'?: Array<WorkDebtor>;
'meta'?: {
'select'?: Array<string>;
'filter'?: {
'projectId'?: (string | Array<string>);
};
};
}>): WorkPaginatedDocumented & {
'data'?: Array<WorkDebtor>;
'meta'?: {
'select'?: Array<string>;
'filter'?: {
'projectId'?: (string | Array<string>);
};
};
} => r.body)
    );
  }

  /** Path part for operation `debtorsV2ControllerCreate()` */
  static readonly DebtorsV2ControllerCreatePath = '/v2/debtors';

  /**
   * Required permissions: debtors:create, debtors:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `debtorsV2ControllerCreate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  debtorsV2ControllerCreate$Response(
    params: {
      body: WorkCreateDebtorDto
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkDebtor>> {
    const rb = new RequestBuilder(this.rootUrl, WorkDebtorsV2Service.DebtorsV2ControllerCreatePath, 'post');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkDebtor>;
      })
    );
  }

  /**
   * Required permissions: debtors:create, debtors:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `debtorsV2ControllerCreate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  debtorsV2ControllerCreate(
    params: {
      body: WorkCreateDebtorDto
    },
    context?: HttpContext
  ): Observable<WorkDebtor> {
    return this.debtorsV2ControllerCreate$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkDebtor>): WorkDebtor => r.body)
    );
  }

  /** Path part for operation `debtorsV2ControllerFindLatestQrNumber()` */
  static readonly DebtorsV2ControllerFindLatestQrNumberPath = '/v2/debtors/latestQrNumber';

  /**
   * Required permissions: debtors:read, debtors:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `debtorsV2ControllerFindLatestQrNumber()` instead.
   *
   * This method doesn't expect any request body.
   */
  debtorsV2ControllerFindLatestQrNumber$Response(
    params?: {
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkDebtorLatestQrnumberDto>> {
    const rb = new RequestBuilder(this.rootUrl, WorkDebtorsV2Service.DebtorsV2ControllerFindLatestQrNumberPath, 'get');
    if (params) {
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkDebtorLatestQrnumberDto>;
      })
    );
  }

  /**
   * Required permissions: debtors:read, debtors:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `debtorsV2ControllerFindLatestQrNumber$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  debtorsV2ControllerFindLatestQrNumber(
    params?: {
    },
    context?: HttpContext
  ): Observable<WorkDebtorLatestQrnumberDto> {
    return this.debtorsV2ControllerFindLatestQrNumber$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkDebtorLatestQrnumberDto>): WorkDebtorLatestQrnumberDto => r.body)
    );
  }

  /** Path part for operation `debtorsV2ControllerFindOneById()` */
  static readonly DebtorsV2ControllerFindOneByIdPath = '/v2/debtors/{id}';

  /**
   * Required permissions: debtors:read, debtors:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `debtorsV2ControllerFindOneById()` instead.
   *
   * This method doesn't expect any request body.
   */
  debtorsV2ControllerFindOneById$Response(
    params: {
      id: number;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkDebtor>> {
    const rb = new RequestBuilder(this.rootUrl, WorkDebtorsV2Service.DebtorsV2ControllerFindOneByIdPath, 'get');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkDebtor>;
      })
    );
  }

  /**
   * Required permissions: debtors:read, debtors:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `debtorsV2ControllerFindOneById$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  debtorsV2ControllerFindOneById(
    params: {
      id: number;
    },
    context?: HttpContext
  ): Observable<WorkDebtor> {
    return this.debtorsV2ControllerFindOneById$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkDebtor>): WorkDebtor => r.body)
    );
  }

  /** Path part for operation `debtorsV2ControllerDelete()` */
  static readonly DebtorsV2ControllerDeletePath = '/v2/debtors/{id}';

  /**
   * Required permissions: debtors:delete, debtors:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `debtorsV2ControllerDelete()` instead.
   *
   * This method doesn't expect any request body.
   */
  debtorsV2ControllerDelete$Response(
    params: {
      id: number;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<void>> {
    const rb = new RequestBuilder(this.rootUrl, WorkDebtorsV2Service.DebtorsV2ControllerDeletePath, 'delete');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(
      rb.build({ responseType: 'text', accept: '*/*', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
      })
    );
  }

  /**
   * Required permissions: debtors:delete, debtors:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `debtorsV2ControllerDelete$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  debtorsV2ControllerDelete(
    params: {
      id: number;
    },
    context?: HttpContext
  ): Observable<void> {
    return this.debtorsV2ControllerDelete$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `debtorsV2ControllerUpdate()` */
  static readonly DebtorsV2ControllerUpdatePath = '/v2/debtors/{id}';

  /**
   * Required permissions: debtors:update, debtors:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `debtorsV2ControllerUpdate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  debtorsV2ControllerUpdate$Response(
    params: {
      id: number;
      body: WorkUpdateDebtorDto
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<void>> {
    const rb = new RequestBuilder(this.rootUrl, WorkDebtorsV2Service.DebtorsV2ControllerUpdatePath, 'patch');
    if (params) {
      rb.path('id', params.id, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(
      rb.build({ responseType: 'text', accept: '*/*', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
      })
    );
  }

  /**
   * Required permissions: debtors:update, debtors:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `debtorsV2ControllerUpdate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  debtorsV2ControllerUpdate(
    params: {
      id: number;
      body: WorkUpdateDebtorDto
    },
    context?: HttpContext
  ): Observable<void> {
    return this.debtorsV2ControllerUpdate$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `debtorsV2ControllerGetDebtorSumInclForProject()` */
  static readonly DebtorsV2ControllerGetDebtorSumInclForProjectPath = '/v2/debtors/getDebtorSumInclForProject/{projectId}';

  /**
   * Required permissions: debtors:read, projectrevenues:read, projects:read, debtors:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `debtorsV2ControllerGetDebtorSumInclForProject()` instead.
   *
   * This method doesn't expect any request body.
   */
  debtorsV2ControllerGetDebtorSumInclForProject$Response(
    params: {
      projectId: number;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<number>> {
    const rb = new RequestBuilder(this.rootUrl, WorkDebtorsV2Service.DebtorsV2ControllerGetDebtorSumInclForProjectPath, 'get');
    if (params) {
      rb.path('projectId', params.projectId, {});
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: parseFloat(String((r as HttpResponse<any>).body)) }) as StrictHttpResponse<number>;
      })
    );
  }

  /**
   * Required permissions: debtors:read, projectrevenues:read, projects:read, debtors:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `debtorsV2ControllerGetDebtorSumInclForProject$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  debtorsV2ControllerGetDebtorSumInclForProject(
    params: {
      projectId: number;
    },
    context?: HttpContext
  ): Observable<number> {
    return this.debtorsV2ControllerGetDebtorSumInclForProject$Response(params, context).pipe(
      map((r: StrictHttpResponse<number>): number => r.body)
    );
  }

  /** Path part for operation `debtorsV2ControllerRegisterPaymentReminder()` */
  static readonly DebtorsV2ControllerRegisterPaymentReminderPath = '/v2/debtors/{id}/register-payment-reminder';

  /**
   * Required permissions: debtors:update, debtors:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `debtorsV2ControllerRegisterPaymentReminder()` instead.
   *
   * This method doesn't expect any request body.
   */
  debtorsV2ControllerRegisterPaymentReminder$Response(
    params: {
      id: number;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkDebtor>> {
    const rb = new RequestBuilder(this.rootUrl, WorkDebtorsV2Service.DebtorsV2ControllerRegisterPaymentReminderPath, 'post');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkDebtor>;
      })
    );
  }

  /**
   * Required permissions: debtors:update, debtors:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `debtorsV2ControllerRegisterPaymentReminder$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  debtorsV2ControllerRegisterPaymentReminder(
    params: {
      id: number;
    },
    context?: HttpContext
  ): Observable<WorkDebtor> {
    return this.debtorsV2ControllerRegisterPaymentReminder$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkDebtor>): WorkDebtor => r.body)
    );
  }

  /** Path part for operation `debtorsV2ControllerRegisterInvoiceSent()` */
  static readonly DebtorsV2ControllerRegisterInvoiceSentPath = '/v2/debtors/{id}/register-invoice-sent';

  /**
   * Required permissions: debtors:update, debtors:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `debtorsV2ControllerRegisterInvoiceSent()` instead.
   *
   * This method doesn't expect any request body.
   */
  debtorsV2ControllerRegisterInvoiceSent$Response(
    params: {
      id: number;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkDebtor>> {
    const rb = new RequestBuilder(this.rootUrl, WorkDebtorsV2Service.DebtorsV2ControllerRegisterInvoiceSentPath, 'post');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkDebtor>;
      })
    );
  }

  /**
   * Required permissions: debtors:update, debtors:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `debtorsV2ControllerRegisterInvoiceSent$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  debtorsV2ControllerRegisterInvoiceSent(
    params: {
      id: number;
    },
    context?: HttpContext
  ): Observable<WorkDebtor> {
    return this.debtorsV2ControllerRegisterInvoiceSent$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkDebtor>): WorkDebtor => r.body)
    );
  }

  /** Path part for operation `debtorsV2ControllerSplit()` */
  static readonly DebtorsV2ControllerSplitPath = '/v2/debtors/{id}/split';

  /**
   * Required permissions: debtors:create, debtors:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `debtorsV2ControllerSplit()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  debtorsV2ControllerSplit$Response(
    params: {
      id: number;
      body: WorkSplitDebtorDto
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<Array<WorkDebtor>>> {
    const rb = new RequestBuilder(this.rootUrl, WorkDebtorsV2Service.DebtorsV2ControllerSplitPath, 'post');
    if (params) {
      rb.path('id', params.id, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<WorkDebtor>>;
      })
    );
  }

  /**
   * Required permissions: debtors:create, debtors:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `debtorsV2ControllerSplit$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  debtorsV2ControllerSplit(
    params: {
      id: number;
      body: WorkSplitDebtorDto
    },
    context?: HttpContext
  ): Observable<Array<WorkDebtor>> {
    return this.debtorsV2ControllerSplit$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<WorkDebtor>>): Array<WorkDebtor> => r.body)
    );
  }

  /** Path part for operation `debtorsV2ControllerToggleSuspended()` */
  static readonly DebtorsV2ControllerToggleSuspendedPath = '/v2/debtors/{id}/toggle-suspended';

  /**
   * Required permissions: debtors:update, debtors:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `debtorsV2ControllerToggleSuspended()` instead.
   *
   * This method doesn't expect any request body.
   */
  debtorsV2ControllerToggleSuspended$Response(
    params: {
      id: number;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkDebtor>> {
    const rb = new RequestBuilder(this.rootUrl, WorkDebtorsV2Service.DebtorsV2ControllerToggleSuspendedPath, 'post');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkDebtor>;
      })
    );
  }

  /**
   * Required permissions: debtors:update, debtors:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `debtorsV2ControllerToggleSuspended$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  debtorsV2ControllerToggleSuspended(
    params: {
      id: number;
    },
    context?: HttpContext
  ): Observable<WorkDebtor> {
    return this.debtorsV2ControllerToggleSuspended$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkDebtor>): WorkDebtor => r.body)
    );
  }

}
